import { render } from "./TeamlessInboxNavItem.vue?vue&type=template&id=498d7346"
import script from "./TeamlessInboxNavItem.vue?vue&type=script&lang=js"
export * from "./TeamlessInboxNavItem.vue?vue&type=script&lang=js"
script.render = render

export default script